import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Injectable()

  export class NavigationService {
    constructor(private router: Router) {
  }
  
  goToHome(){
    this.router.navigate(['/dashboard'])
  }

  dashBoardView(actionInfo) {
    this.router.navigate(['/dashboard/', + actionInfo])
  }

  dashBoardLevelView(id: number, actionInfo: number) {
    console.log(id, actionInfo, "navigation");
    this.router.navigate(['/dashboard/',+ id, actionInfo]);
  }


  // goToBusAddForm(actionInfo: number, id: number){
  //   this.router.navigate(['/addbusdetail/' +actionInfo, id])
  // }
  ///////////////location of facilities ///////////////////

  gotoLocationAddFacility(actionInfo) {
    this.router.navigate(['/locationoffacilities/', actionInfo])
  }

  /////////application grievance//////////

  goToApplicationGrievanceDetail(id, actionInfo){
    this.router.navigate(['/applicationgrievance/'+ id, actionInfo])
  }

  goToGrevienceGridXts(){
    this.router.navigate(['/applicationgrievance'])
  }
  ///// // bus routse///////////
  
  goToBusAddForm(actionInfo: number, id: number){
    this.router.navigate(['/addbusdetail/' +actionInfo, id])
  }
  goToBusGridDetail(){
    this.router.navigate(['/BusSchedule'])
  }
  goToGrievanceDetail(id, actionInfo){
    this.router.navigate(['/grievances/'+ id, actionInfo])
  }

  goToGrevienceGrid(){
    this.router.navigate(['/grievance'])
  }

  ////////// inspection
  gotToAddInspection(id: any, actionId: any) {
    this.router.navigate(['/inspection/',+ id, actionId])
  }
  ////////////// 

  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  goToTimeSheet(id: number, actionInfo: number) {
    //;
    this.router.navigate(['/timesheet/' + id, actionInfo]);
  }



  //my code 
  goToTimeSheets(date: Date, actionInfo: number) {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    this.router.navigate(['/timesheet/' + formattedDate, actionInfo]);
  }

  gotoTask(id: any, actionInfo: any) {
    this.router.navigate(['/task/' + id, actionInfo])
  }

  gotoTaskAssign(id: any, actionInfo: any) {
    this.router.navigate(['/assigntask/' + id, actionInfo])
  }

  goToproject(id: number, actionInfo: number) {
    //;
    this.router.navigate(['/projectdetails/' + id, actionInfo]);
  }

  goToMapping(id: any, actionInfo: number) {
    //;
    this.router.navigate(['/mappingdetails/' + id, actionInfo]);
  }

  goToemployeeview(id: any, actionInfo: number) {
    //;
    this.router.navigate(['/weeklytimesheetaprove/' + id, actionInfo]);
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }

  goToUnAuthorized() {
    this.router.navigate(['/unauthorized']);
  }

  goToSessionTimedOut() {
    this.router.navigate(['/sessiontimedout']);
  }

  isOnLoginScreen(): boolean {
    return this.router.url === '/login';
  }

  goToUser(id: number, actionInfo: number) {
    this.router.navigate(['/users/' + id, actionInfo]);
  }

  goToProfile(id: number, actionInfo: number) {
    this.router.navigate(['/profile/' + id, actionInfo]);
  }
  gotoEmployeeDetails(id: number, actionInfo: number) {
    this.router.navigate(['/addbusdetail/' + id, actionInfo])
  }

  gotoEmployee() {
    this.router.navigate(['/timesheet/'])
  }
  gotoTaskgrid() {
    //
    this.router.navigate(['/task/'])
  }
  gotoExcelUpload() {
    this.router.navigate(['/upload'])
  }
  gotodesignation() {
    this.router.navigate(['/designation'])
  }

  gotoAssignTaskgrid() {
    this.router.navigate(['/assigntask/'])
  }

  ///bvg

  gotoBvgaAction(id:number, actionInfo:number) {
    this.router.navigate(['/grievances/'+ id, actionInfo])
  }

  //dash board


}

